import { Container, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import { dateFormat } from '../../util/DateUtil';
import { currencyRound } from '../../util/DoubleUtil';

const LancamentoViewSimple = ({ lancamento }) => {
    return (
        <Container maxWidth='sm' component={Paper}>
            <Grid container spacing={3}>
                <Grid size={12}>
                    <Typography variant='h5'>
                        Lançamento
                    </Typography>
                </Grid>
                <Grid>
                    <Typography variant='body1'>
                        Ano Letivo
                    </Typography>
                    <Typography variant='subtitle1'>
                        {lancamento?.anoLetivo}
                    </Typography>
                </Grid>
                <Grid>
                    <Typography variant='body1'>
                        Aluno
                    </Typography>
                    <Typography variant='subtitle1'>
                        {lancamento?.aluno?.nome}
                    </Typography>
                </Grid>
                <Grid>
                    <Typography variant='body1'>
                        Histórico
                    </Typography>
                    <Typography variant='subtitle1'>
                        {lancamento?.historicoLancamento?.descricao}
                    </Typography>
                </Grid>
                <Grid>
                    <Typography variant='body1'>
                        Vencimento
                    </Typography>
                    <Typography variant='subtitle1'>
                        {lancamento && lancamento.dataVencimento ? dateFormat(lancamento.dataVencimento) : ''}
                    </Typography>
                </Grid>
                <Grid>
                    <Typography variant='body1'>
                        Valor
                    </Typography>
                    <Typography variant='subtitle1'>
                        {lancamento && lancamento.valor ? "R$ " + currencyRound(lancamento.valor) : ''}
                    </Typography>
                </Grid>
                <Grid>
                    <Typography variant='body1'>
                        Valor Atual
                    </Typography>
                    <Typography variant='subtitle1'>
                        {lancamento && lancamento.valorReajustado ? "R$ " + currencyRound(lancamento.valorReajustado) : ''}
                    </Typography>
                </Grid>

            </Grid>
        </Container>
    );
}

export default LancamentoViewSimple;